import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DiagramsView } from '@/features/diagrams/DiagramsView.js';
import { ensureDiagramsEnabled } from '@/features/diagrams/guard.js';

// The workspace's diagram and whiteboard gallery. Pure SPA route — data comes from
// /v1/diagrams via TanStack Query.
export const Route = createFileRoute('/diagrams/')({
  beforeLoad: async () => {
    await ensureDiagramsEnabled();
  },
  component: DiagramsPage,
});

function DiagramsPage(): JSX.Element {
  return <DiagramsView />;
}
